import { Table, Spin } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { PropertyData, TABLE_STATE } from '../CampaignReport.type';
import { useIsMobile } from 'Hooks';
import PaginationElement from 'PhishingManager/components/Pagination';
import { PROPERTY_TABLE_COLUMNS } from '../CampaignReport.constant';
import PropertyCard from './PropertyCard';
import { ColumnsType } from 'antd/es/table';
import PropertyListItem from './PropertyListItem';
import InfinityScrollWrapper from 'Components/InfinityScroll/InfinityScrollWrapper';
import { useTranslation } from 'react-i18next';

const PAGE_SIZE = 10;
const PropertyTab = ({ tableState }: { tableState: TABLE_STATE }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const isMobile = useIsMobile(951);
    const { t } = useTranslation();

    const { propertyData } = tableState;
    const tableColumn: ColumnsType<any> = PROPERTY_TABLE_COLUMNS(t);

    const { tableData, tableKey }: { tableData: PropertyData[], tableKey: number } = useMemo(() => {
        const startIdx = PAGE_SIZE * (currentPage - 1);
        return {
            tableKey: Math.random() * currentPage,
            tableData: isMobile ? propertyData.slice(0, startIdx + PAGE_SIZE) : propertyData.slice(startIdx, startIdx + PAGE_SIZE),
        }
    }, [currentPage, propertyData, isMobile]);

    useEffect(() => {
        if (tableState.isPropertyLoading) setCurrentPage(1);
    }, [tableState.isPropertyLoading])

    return <Spin spinning={tableState.isPropertyLoading}>
        <div className="report-section">
            <div className="table-header">
                <div className='description'>{t(`phishingManager.report.table.header.property`)}</div>
            </div>
            {tableData.length ? <div className='cards-flex'>
                <PropertyCard title={`${tableState.propertyExtraData.averagePassRate}%`} desc={t('phishingManager.report.table.propertyCard.average')} iconType='trendingArrow' />
                <PropertyCard title={`${tableState.propertyExtraData.bestPerforming.name}`} desc={t('phishingManager.report.table.propertyCard.best')} tagValue={tableState.propertyExtraData.bestPerforming.passRate} />
                <PropertyCard title={`${tableState.propertyExtraData.belowPassRate}`} desc={t('phishingManager.report.table.propertyCard.below90')} iconType='phishingManagerWarningModalPrefix' />
            </div> : null}

            {(!isMobile || !tableData.length) ? <div className='table-section'>
                <Table
                    key={tableKey}
                    rowKey={(record) => record.key || record.id}
                    className="report-table"
                    dataSource={tableData}
                    showHeader={tableData.length > 0}
                    columns={tableColumn}
                    pagination={false}
                    showSorterTooltip={false}
                    rowClassName={(_, index) => `${index % 2 === 0 ? "bg-white" : "bg-gray"}`}
                />
                <PaginationElement
                    total={propertyData.length}
                    pageSize={PAGE_SIZE}
                    current={currentPage}
                    onChange={setCurrentPage}
                />
            </div> : <div className='list-section'>
                <InfinityScrollWrapper
                    dataLength={tableData.length}
                    hasMore={tableData.length < propertyData.length}
                    onLoadMore={() => setTimeout(() => setCurrentPage(prev => prev + 1), 500)}
                    height={600}
                    endMessageText={t('phishingManager.campaignSetup.step3.property.allItemLoaded')}
                    scrollableId="user-data-scroll-container">
                    {tableData.map((item, idx) => <PropertyListItem t={t} propertyData={item as PropertyData} key={idx} />)}
                </InfinityScrollWrapper>
            </div>}
        </div>
    </Spin>
}

export default PropertyTab;